import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { size } from "lodash";
import { useRef } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-react";
import { reactMarkdownComp } from "../../../../../../../Constants/reactMarkdownComp";
import useTab from "../../../../hooks/useTab";
import {
  ItemContentContainer,
  ItemWrapper,
  RetrievalExportHeaderContainer,
  RetrievalGridContainer,
  StyledAGGrid,
} from "../../../../style";
import TitleWrapper from "../../../TitleWrapper";
import remarkGfm from "remark-gfm";

type Props = {
  output: any;
  index: number;
  isClosed: boolean;
  handleCollapse: (index: number) => () => void;
};

const RetrevialBlock = ({ output, index, isClosed, handleCollapse }: Props) => {
  const { animationStyles } = useTab({ isClosed });
  const gridRef = useRef<any>(null);

  const handleExportCSV = () => {
    if (gridRef.current) {
      gridRef.current.api.exportDataAsCsv({
        fileName: `retrieval-data-${Date.now()}.csv`,
      });
    }
  };

  return (
    <ItemWrapper>
      <TitleWrapper
        title="Retrieval"
        handleCollapse={handleCollapse}
        index={index}
        animationStyles={animationStyles}
      />
      <ItemContentContainer sx={animationStyles.displayContainer}>
        <Box>
          <ReactMarkdown
            children={output?.summary}
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw] as any}
            components={reactMarkdownComp}
          />
        </Box>
        {output?.sql_query && (
          <Box sx={{ my: 1 }}>
            <RetrievalExportHeaderContainer>
              <Typography variant="body2" fontWeight="bold">
                Generated SQL Query
              </Typography>
            </RetrievalExportHeaderContainer>

            <ReactMarkdown
              children={output?.sql_query}
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[rehypeRaw] as any}
              components={reactMarkdownComp}
            />
          </Box>
        )}

        {size(output?.table) > 0 && (
          <>
            <RetrievalExportHeaderContainer>
              <Typography variant="body2" fontWeight="bold">
                Retrieval Results
              </Typography>
              <Tooltip title="Export as CSV">
                <IconButton onClick={handleExportCSV} size="small">
                  <FileDownloadIcon />
                </IconButton>
              </Tooltip>
            </RetrievalExportHeaderContainer>

            <RetrievalGridContainer onClick={(e) => e.stopPropagation()}>
              <StyledAGGrid
                ref={gridRef}
                className="ag-theme-material top-border-0"
                suppressContextMenu
                suppressMovableColumns
                suppressDragLeaveHidesColumns
                pagination
                headerHeight={40}
                rowHeight={40}
                domLayout="autoHeight"
                rowData={output?.table}
                columnDefs={Object.keys(output?.table[0]).map((key) => ({
                  field: key,
                }))}
              />
            </RetrievalGridContainer>
          </>
        )}
      </ItemContentContainer>
    </ItemWrapper>
  );
};

export default RetrevialBlock;
